import { type Device, DeviceEmpty } from "$lib/data/type/device/device"
import { type DeviceToken, DeviceTokenEmpty } from "$lib/data/type/device/device-token"
import type { Permission } from "$lib/data/type/permission"

class DeviceStore {
  platform = $state("")
  device = $state<Device>(DeviceEmpty)
  deviceToken = $state<DeviceToken>(DeviceTokenEmpty)

  permissions = $state<Permission[]>([])

  geolocation = $state<GeolocationPosition | null>(null)
  geolocationRequestId = $state<number>(0)

  update = (platform: string, device: Device, deviceToken: DeviceToken, permissions: Permission[]) => {
    this.platform = platform
    this.device = device
    this.deviceToken = deviceToken
    this.permissions = permissions
  }
  permissionsUpdate = (permissions: Permission[]) => {
    this.permissions = permissions
  }
  platformUpdate = (platform: string) => {
    this.platform = platform
  }
  deviceUpdate = (device: Device) => {
    this.device = device
  }
  deviceTokenUpdate = (deviceToken: DeviceToken) => {
    this.deviceToken = deviceToken
  }
  geolocationUpdate = (geolocation: GeolocationPosition) => {
    this.geolocation = geolocation
  }
  geolocationRequestUpdate = () => {
    this.geolocationRequestId = this.geolocationRequestId + 1
  }
}

export const deviceStore = new DeviceStore()